import ApiService from "@/core/services/ApiService";

class MultimediaService {

    public static get(category) {
        ApiService.setHeader()
        return ApiService.get('api/multimedia', category)
    }

    public static getData(params: any) {
        ApiService.setHeader()
        return ApiService.post('api/multimedia', params)
    }

}

export default MultimediaService;